/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { Typography, TextField, Button, Grid } from "@material-ui/core";
import { ipServer } from "../../../config/vars";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  divMain: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    padding: theme.spacing(5),
    // backgroundColor: "blue",
  },
  divBack: {
    cursor: "pointer",
    marginBottom: "20px",
  },
  title: {
    fontFamily: "Roboto",
    fontSize: 32,
    fontWeight: 600,
    color: theme.palette.secondary.dark,
    marginTop: "12%",
  },
  subtitle: {
    fontFamily: "Roboto",
    fontSize: 18,
    color: theme.palette.secondary.light,
  },
  textFieldLabel: {
    fontFamily: "Roboto",
    fontSize: 25,
    color: theme.palette.secondary.light,
    marginTop: "8%",
  },
  textFieldCustom: {
    "& label.Mui-focused": {
      color: "#6C6C6C",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "yellow",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#E6E6E6",
      },
      "&:hover fieldset": {
        borderColor: "#6C6C6C",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    boxShadow: "0 0 10px 0 rgba(155, 155, 155, 0.22)",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  button: {
    height: "56px",
    marginTop: "20%",
    marginBottom: "20%",
    borderRadius: "4px",
    backgroundColor: theme.palette.primary.main,
    textTransform: "none",
  },
  typoButton: {
    fontFamily: "Roboto",
    fontSize: 28,
    fontWeight: 300,
    color: theme.palette.neutral.primary,
  },
}));

export default function NewPassword(props) {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleChange = (e) => {
    // console.log(e.target.value);
    props.setPasswordData({
      ...props.passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const checkPasswords = (password, confirmPassword) => {
    if (password == "" || confirmPassword == "") {
      enqueueSnackbar("Favor de ingresar los datos requeridos", {
        variant: "error",
      });
      return false;
    }
    return true;
  };

  const checkPassword = (password, confirmPassword) => {
    if (password != confirmPassword) {
      enqueueSnackbar("El password no coincide, favor de verificar", {
        variant: "error",
      });
      return false;
    }
    return true;
  };

  const onSubmit = () => {
    if (
      !checkPasswords(
        props.passwordData.password,
        props.passwordData.confirmPassword
      )
    )
      return;
    if (
      !checkPassword(
        props.passwordData.password,
        props.passwordData.confirmPassword
      )
    )
      return;

    axios
      .post(
        `${ipServer}/api/v1/security/user/password/change/`,
        {
          Password: props.passwordData.password,
        },
        {
          headers: {
            Authorization: props.passwordData.token,
          },
        }
      )
      .then((response) => {
        // console.log(response.data);
        props.setStep(4);
        enqueueSnackbar("Contraseña modificada correctamente", {
          variant: "success",
        });
      })
      .catch((e) => {
        console.log(e.response);
      });
  };

  return (
    <div className={classes.divMain}>
      <Grid
        item
        xs={10}
        container
        direction="column"
        alignItems="flex-start"
        style={{
          width: "503px",
          height: "100%",
        }}
      >
        <Typography className={classes.title}>
          Ingresa nueva contraseña
        </Typography>
        <Typography className={classes.subtitle}>
          Ingresa la nueva contraseña de tu cuenta
        </Typography>

        <Typography className={classes.textFieldLabel}>Contraseña</Typography>
        <TextField
          id="password"
          type="password"
          variant="outlined"
          fullWidth
          name="password"
          size="medium"
          autoComplete="password"
          onChange={handleChange}
          className={classes.textFieldCustom}
        />

        <Typography className={classes.textFieldLabel}>
          Repetir contraseña
        </Typography>
        <TextField
          id="confirmPassword"
          type="password"
          variant="outlined"
          fullWidth
          name="confirmPassword"
          size="medium"
          autoComplete="confirmPassword"
          onChange={handleChange}
          className={classes.textFieldCustom}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={onSubmit}
          className={classes.button}
        >
          <Typography className={classes.typoButton}>Siguiente</Typography>
        </Button>
      </Grid>
    </div>
  );
}
